import { Component, Injector, OnInit } from '@angular/core';
import {
  BaseResourceListComponent, Coluna, Favorecido, FavorecidoContato, FavorecidoService, Filtro, FormatoExportacao, LoginContabil, TipoContato
} from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'lib-favorecido-lst',
  templateUrl: './favorecido-lst.component.html'
})
export class FavorecidoLstComponent extends BaseResourceListComponent<Favorecido, LoginContabil> implements OnInit {

  /**
   * Declaração de variáveis
   */
  public listaTipos: {
    tipo: 'A' | 'I' | 'T',
    nome: string
  }[];

  public inativo: 'T' | 'A' | 'I' = 'A';

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private favorecidoService: FavorecidoService) {
    super(favorecidoService, injector);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'cidade';
  }

  protected condicoesGrid(): {} {
    let condicoesGrid = {
      ['cidade.id']: this.login.cidade.id
    };
    if (this.inativo !== 'T')
      condicoesGrid['inativo'] = this.inativo === 'I';
    return condicoesGrid;
  }

  protected ordenacaoGrid(): string[] {
    return ['id$DESC'];
  }

  protected filtrosGrid(): Filtro {
    return {
      number: ['cpf_cnpj'],
      text: ['nome', 'cidade'],
    };
  }

  protected afterInit(): void {
    this.carregarTipos();
  }

  public beforeInit(): void {
    this.usarExtendido = true;
  }

  protected acaoRemover(model: Favorecido): Observable<Favorecido> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Código', coluna: 'id' },
      { titulo: 'CPF/CNPJ', coluna: 'cpf_cnpj' },
      { titulo: 'Nome/Razão social', coluna: 'nome' },
      { titulo: 'Endereço', coluna: 'endereco' },
      { titulo: 'Bairro', coluna: 'bairro' },
      { titulo: 'Cidade', coluna: 'municipio' },
      { titulo: 'Telefone', coluna: 'telefone' },
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    parametros['relations'] = this.relations();
    this.favorecidoService
      .extendido(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          if (formato === 'pdf') {
            this.imprimir('LISTAGEM DE FORNECEDORES/CREDORES',
              this.login.usuario.nome, this.login.orgao.nome, this.login.brasao, 'landscape',
              'Listagem fornecedor/credor', ['auto', 'auto', '*', '*', '*', 'auto', 'auto'], lista.content);
          } else {
            this.exportar(formato, lista.content);
          }
        },
        () => alert('erro ao retornar lista')
      );
  }


  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  private carregarTipos() {
    this.listaTipos = [
      { tipo: 'T', nome: 'TODOS' },
      { tipo: 'A', nome: 'ATIVOS' },
      { tipo: 'I', nome: 'INATIVO' }
    ]
  }

}
